import Logo from '../../Assets/images/Logo.svg';
import EnLogo from '../../Assets/images/LightEnLogo.svg';

import { Link } from 'react-router-dom';
import { useContext } from 'react';
import { DirectionContext } from '../Contexts/DirectionContext';
import { Trans } from 'react-i18next';
import { ServicesData } from '../ServicesData/ServicesData'
import { contentData } from '../Blogs/FullBlogs'
import frame from "../../Assets/images/Frame 124.png"
export default function Footer() {
  const { dir } = useContext(DirectionContext);
  const cardsData = ServicesData
  const displayedCards = cardsData.slice(0, 6);
  const hasMoreCards = cardsData.length > 6;
  const blog = contentData;
  const displayedBlogs = blog.slice(0, 3);

  return (
    <footer className="container-fluid FooterContainer py-4 footer">
      <div className="row justify-content-lg-end w-100">
        {/* Logo  */}
        <div className="col-lg-auto  mb-4 mx-2">
          <img
            src={dir === 'ltr' ? EnLogo : Logo}
            alt="Company Logo"
            width="250"
            height="auto"
          />
          <p className="my-4 footerWorkingHours" >
            <Trans i18nKey="footerWorkingHours"> مواعيد العمل: الأحد - الخميس | 9:00 صباحًا - 6:00 مساءً </Trans>
          </p>
          <nav aria-label="Secondary footer navigation ">
            <ul className="d-flex list-unstyled mb-4 p-0">
              <li>
                <Link to="/info/contact" className="text-decoration-none">
                  <i className="bi bi-geo-alt"></i>
                </Link>
              </li>
              <li className="FooterTitles">
                <a href="https://wa.me/966557000907" className="text-decoration-none">
                  <i className="bi bi-telephone"></i>
                </a>
              </li>
              <li>
                <a href="mailto:Info@AJL.sa" className="text-decoration-none">
                  <i className="bi bi-envelope"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>

        <div className="col">
          <div className="row">
            <div className="col-auto">
              {/* Primary Links */}
              <nav aria-label="Primary footer navigation">
                <ul className="d-flex flex-wrap list-unstyled flex-column" style={{ gap: "10px" }}>
                  <li className="FooterTitles">
                    <Link to="info/AboutUs" className="text-decoration-none">
                      <Trans i18nKey="home">الرئيسية</Trans>
                    </Link>
                  </li>
                  <li className="FooterTitles">
                    <Link to="info/AboutUs" className="text-decoration-none">
                      <Trans i18nKey="footerAboutUs">من نحن</Trans>
                    </Link>
                  </li>
                  <li className="FooterTitles">
                    <Link to="info/services" className="text-decoration-none">
                      <Trans i18nKey="footerServices">خدماتنا</Trans>
                    </Link>
                  </li>
                  <li className="FooterTitles">
                    <Link to="info/Blogs" className="text-decoration-none">
                      <Trans i18nKey="footerBlog">المدونة</Trans>
                    </Link>
                  </li>
                  <li className="FooterTitles">
                    <Link to="info/contact" className="text-decoration-none">
                      <Trans i18nKey="footerContact">تواصل معنا</Trans>
                    </Link>
                  </li>
                  <li className="FooterTitles">
                    <Link to="info/contact" className="text-decoration-none">
                      <Trans i18nKey="FAQTitle">الأسئلة الشائعة</Trans>
                    </Link>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="col-auto">
              {/* Primary Links */}
              <nav aria-label="Primary footer navigation">
                <ul className="d-flex flex-wrap list-unstyled flex-column" style={{ gap: "10px" }}>
                  <li className="FooterTitles">
                    <Link to="info/AboutUs" className="text-decoration-none">
                      <Trans i18nKey="footerAboutUs">من نحن</Trans>
                    </Link>
                  </li>
                  <li className="Pagecontent">
                    <Trans i18nKey="vision.title">رؤيتنا</Trans>
                  </li>
                  <li className="Pagecontent">
                    <Trans i18nKey="values.title">قيمنا</Trans>
                  </li>
                </ul>
              </nav>
            </div>
            <div className="col-auto">
              {/* Primary Links */}
              <nav aria-label="Primary footer navigation">
                <ul className="d-flex flex-wrap list-unstyled flex-column" style={{ gap: "10px" }}>
                  <li className="FooterTitles">
                    <Link to="/info/services" className="text-decoration-none">
                      <Trans i18nKey="services">خدماتنا</Trans>
                    </Link>
                  </li>
                  {displayedCards.map(card => (
                    <li className="Pagecontent" key={card.id}>
                      {dir === 'ltr' ? card.TitleEn : card.Title}
                    </li>
                  ))}
                  {/* Show More button only if there are more than 6 cards */}
                  {hasMoreCards && (
                    <div className="mt-3">
                      <Link to="/info/services" className="btn-link">
                        <button className="FooterTitles bg-transparent border-0  py-2 d-flex align-items-center">
                          <Trans i18nKey="moreButton">
                            {dir === 'ltr' ? 'More' : 'المزيد'}
                            <i className={dir === 'ltr' ? 'fa-solid fa-chevron-right px-2' : 'fa-solid fa-chevron-left px-2'}></i>
                          </Trans>
                        </button>
                      </Link>
                    </div>
                  )}
                </ul>
              </nav>
            </div>
            <div className="col-md-auto">
              {/* Primary Links */}
              <nav aria-label="Primary footer navigation">
                <ul className="d-flex flex-wrap list-unstyled flex-column" style={{ gap: "10px" }}>
                  <li className="FooterTitles">
                    <Link to="/info/Blogs" className="text-decoration-none">
                      <Trans i18nKey="Blogs">مدونة</Trans>
                    </Link>
                  </li>
                  {displayedBlogs.map(Blog => (
                    <li className="Pagecontent" key={Blog.id}>
                      {dir === 'ltr' ? Blog.title_en : Blog.title}
                    </li>
                  ))}
                </ul>
              </nav>
            </div>
          </div>
        </div>
        <div className="col-auto">
          <img src={frame} alt="logo illustration" className='footer_design_img' />
        </div>


        <div className="col-12">
          <hr className="my-2 mx-2" />
        </div>

        {/* Copyright */}
        <div className="col-12 text-center">
          <p className="mb-0 company" style={{ fontSize: "12px" }}>
            <Trans i18nKey="footerCopyright">
              جميع الحقوق محفوظة لشركة غيوم الودق لتقنية المعلومات ©
            </Trans>
          </p>
        </div>
      </div>
    </footer>
  );
}
